// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import point_tc from '@/components/point_tc.vue';
import page_tc from '@/components/page_tc.vue';
import ticket_tc from '@/components/ticket_tc.vue';
import site from '@/components/site.vue';
import nav from '@/components/nav.vue';
import store from './store'
import { get, isLoadingPending } from '@/utils/request'
import langText from '@/utils/lang-text'
// import 'font-awesome/css/font-awesome.min.css'
Vue.prototype.$axios = axios
Vue.component('navv', nav)
Vue.component('site', site)
Vue.component('point_tc', point_tc)
Vue.component('page_tc', page_tc)
Vue.component('ticket_tc', ticket_tc)
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.prototype.get = get
Vue.prototype.web_tit = '乐行巴士-日本巴士预订订票官网，日本夜行巴士，日本昼行巴士，日本旅游巴士，日本旅行巴士'
Vue.prototype.$store = store

Vue.prototype.to_hi = function (datetime) {
  if (!datetime) {
    return ''
  }
  return datetime.substr(0, 16)
}

Vue.prototype.to_ym = function (datetime) {
  if (!datetime) {
    return ''
  }
  return datetime.substr(0, 7)
}

Vue.prototype.admin_url = 'http://serverapi.173key.cn'
Vue.prototype.city_dis = function (s) {
  if (!s) {
    return ''
  }
  return s.split('(')[0].split('（')[0]
}



Vue.prototype.to_ymd = function (datetime) {
  if (!datetime) {
    return ''
  }
  return datetime.substr(0, 10)
}


function cache(k, v) {
  // console.log('dodo', v)
  if (typeof (v) == 'undefined') {
    // get

    return JSON.parse(localStorage.getItem(k));
  } else if (v == null) {
    // del
    // console.log('del')
    localStorage.removeItem(k);
  } else {
    // set
    // console.log('set', v)
    localStorage.setItem(k, JSON.stringify(v));
  }

}
// 多语言：URL 前缀是语言唯一真相（/en/、/jp/，无前缀 = 中文）。
// 不读 localStorage 判定语言——预渲染并行渲染各语言页面共享 storage，读缓存会串语言。
// 切换语言通过带前缀的 URL 整页跳转（见 nav_list 的 set_lang），base 在 router 中同步识别。
function currentLang() {
  const m = location.pathname.match(/^\/(en|jp|kor|tw)(\/|$)/)
  return m ? m[1] : 'cn'
}
Vue.prototype.cur_lang = currentLang
;(function initLang() {
  const lang = currentLang()
  cache('lang_config', lang) // 仅供历史遗留代码兜底，读取一律走 cur_lang()
  const HTML_LANG = { cn: 'zh', tw: 'zh-TW', jp: 'ja', kor: 'ko' }
  document.documentElement.lang = HTML_LANG[lang] || lang
})()
Vue.prototype.cache = cache

let ldata = {}
let foot = []
const start = async () => {

  if (0 && cache('lang')) {
    ldata = cache('lang')
  } else {
    await get('/lang').then((e) => {
      foot = e.foot
      ldata = e.lang
      // console.log(e)
      cache('lang', ldata)
    });

  }
  Vue.prototype.foot_adv = foot

  Vue.prototype.$lang = function (k) {
    // console.log(ldata)
    let lang = currentLang()
    // 后台词典尚未补 tw/kor 列时降级：繁中回退简中、韩文回退英文，避免整页显示 '--'
    const dict = ldata[k]
    if (dict && dict[lang] === undefined) lang = lang === 'tw' ? 'cn' : 'en'
    try {
      return ldata[k][lang]

    } catch (err) {
      console.log(err)
      return '--'
    }

  }
  Vue.prototype.c = Vue.prototype.$lang
  // $lt：本地静态文案五语言映射（与后端词典无关），见 utils/lang-text.js
  Vue.prototype.$lt = langText

  Vue.prototype.clearss = function(s) {
    return s.replaceAll('&nbsp;','').replaceAll(' ', '').replaceAll('\\n', '').replaceAll('\n', '')
 
 }
  Vue.prototype.jump2 = function (url) {
    cache('jump_to', url)
    router.push({ path: '/jump/to', query: {}, replace: true })
  }
  Vue.prototype.jump = function (url, para = {}, replace = false) {

    router.push({ path: url, query: para, replace: replace })
  }
  Vue.prototype.back = function () {

    router.back()
  }

  Vue.prototype.decimal = function (v, len = 2) {
    return parseFloat(v).toFixed(len)

  }



  new Vue({
    components: { App },
    router,
    template: '<App/>'
  }).$mount('#app')

  // 预渲染信号：等待页面数据"安静"（带 loading 的请求全部结束并保持 1.5 秒无新请求）
  // 后通知 prerender 抓取 DOM，比固定延时快得多；10 秒兜底强制抓取。
  // 抓取前清理可能残留的 loading 遮罩（挂在 body 上，不清理会被烘焙进静态 HTML，
  // 导致线上页面永久显示"载入中"圈圈）
  const prerenderReady = () => {
    document.querySelectorAll('.el-loading-mask').forEach(el => el.remove())
    document.dispatchEvent(new Event('render-event'))
  }
  const startedAt = Date.now()
  let idleSince = null
  const prerenderTimer = setInterval(() => {
    const elapsed = Date.now() - startedAt
    if (!isLoadingPending()) {
      if (idleSince == null) idleSince = Date.now()
      const idle = Date.now() - idleSince
      if ((elapsed >= 3000 && idle >= 1500) || elapsed >= 10000) {
        clearInterval(prerenderTimer)
        prerenderReady()
      }
    } else {
      idleSince = null
    }
  }, 300)

}

start()



// WEBPACK FOOTER //
// ./src/main.js